/** Shared Recharts style constants — module-level to avoid re-allocating on every render. */
export const TOOLTIP_STYLE = {
  background: "#FFFFFF",
  border: "1px solid #E2DFD6",
  borderRadius: 6,
  fontSize: 12,
};

export const TOOLTIP_WRAPPER = { outline: "none" };

export const AREA_MARGIN = { top: 10, right: 10, left: 0, bottom: 10 };
export const BAR_MARGIN = { top: 10, right: 10, left: 0, bottom: 10 };
export const LINE_MARGIN = { top: 10, right: 30, left: 0, bottom: 10 };

export const CHART_PALETTE = ["#26547C", "#D1603D", "#17A035", "#8B6A14", "#2A5C9C", "#525860"];
